<template>
 <div style="height: 50px; 
            line-height:50px; 
            border-bottom: 2px solid #ccc; 
            display: flex;
            box-shadow: 10px 10px 10px rgba(0,0,0,.3)
            ">
   <div style="width: 200px; 
              padding-left:30px; 
              font-weight: bold; 
              color:rgb(153, 153, 153);
              display:flex;
              font-size: 16px;
              align-items: center;">
     <img :src="imgUrl" class="icon" >
     云上智慧书城
  </div>
   <div style="flex: 1"></div>
   <div style="width: 100px">
     <el-dropdown>
      <span class="el-dropdown-link">
        {{user.nickName}} 
        <!-- <el-icon class="el-icon--right">
          <arrow-down />
          </el-icon> -->
          <span class="iconfont icon-tuichu"></span>

      </span>
       <template #dropdown>
         <el-dropdown-menu>
           <el-dropdown-item @click="exit">退出系统</el-dropdown-item>
         </el-dropdown-menu>
       </template>
     </el-dropdown>
   </div>
 </div>
</template>

<script>
import {ElMessage} from "element-plus";

export default {
  name: "Header",
  props: ['user'],
  data(){
    return{
      user:[],
      imgUrl:require("../assets/icon/login.png")
    }
  },
  created(){
    let userStr = sessionStorage.getItem("user")||"{}"
    this.user = JSON.parse(userStr)
  },
  methods:{
    exit(){
      sessionStorage.removeItem("user")
      this.$router.push("/login")
      ElMessage.success("退出系统成功")
    }
  }

}
</script>

<style scoped>
.icon {
  width: 45px;
  height: 45px;
  padding-top: 5px;
  padding-right: 10px;
}
</style>